import { forwardRef } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Divider from "@mui/material/Divider";
import { useGetUserById, useAcceptTerms } from "../hooks/useMyAccount";
import { ASSETS_BASE_URL } from "../constants";
import { getHasImpersonate } from "../utils/jwt";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const AcceptTermsAndCondition = () => {
  const { data, isLoading } = useGetUserById();
  const { acceptedTermsAndCondition, id } = data || {};
  const { mutate } = useAcceptTerms();

  const handleClose = () => {
    if (id) {
      mutate(id);
    }
  };

  return (
    <Dialog
      open={!getHasImpersonate() && acceptedTermsAndCondition === false && !isLoading}
      TransitionComponent={Transition}
      aria-describedby="terms-and-conditions-alert"
      style={{ zIndex: 2 }}
    >
      <DialogTitle component="h3">{"Terms and Conditions"}</DialogTitle>
      <Divider />
      <DialogContent>
        <DialogContentText
          id="terms-and-conditions-alert"
          style={{ fontFamily: "Quiche-Regular" }}
        >
          Click{" "}
          <b style={{ color: "var(--black)", fontFamily: "Quiche-Medium" }}>
            Acknowledge
          </b>{" "}
          to indicate you accept and agree to the terms of website use presented
          in the{" "}
          <a
            href={`${ASSETS_BASE_URL}/static/termsofservicepro.html`}
            rel="noreferrer noopener"
            target="_blank"
            style={{ textDecoration: "underline", color: "var(--blue)" }}
          >
            Terms and Conditions
          </a>{" "}
          agreement.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button variant="btn-secondary" onClick={handleClose}>
          Acknowledge
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AcceptTermsAndCondition;
